import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// SPEC-175 — ADR-001: prefijo REACT_APP_ obligatorio por Create React App.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const firebaseApp = initializeApp(firebaseConfig);

// SPEC-189 — RN-012: debug token de App Check para desarrollo local. Solo fuera de
// producción, y ANTES de initializeAppCheck, que es cuando el SDK lo lee. Vive en
// .env.development.local, NO en .env.local: el SDK de Firebase lee process.env entero y CRA
// incrusta en el bundle todas las REACT_APP_* del build, así que con el token en .env.local
// un build local lo publicaría (es un bypass completo de App Check).
if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_APPCHECK_DEBUG_TOKEN) {
  (globalThis as unknown as Record<string, unknown>).FIREBASE_APPCHECK_DEBUG_TOKEN =
    process.env.REACT_APP_APPCHECK_DEBUG_TOKEN;
}

// SPEC-189 — RN-003: App Check se inicializa ANTES de getAuth; si no, las primeras
// llamadas de Auth salen sin token de atestación y el enforce las rechaza.
// RN-002: la site key es pública (viaja en el bundle), pero se toma del ambiente para no
// hardcodear un valor de infraestructura. Sin la variable (p. ej. en los tests) no se
// inicializa: no es fail-open, con enforce activo Google rechaza el login igual.
const appCheckSiteKey = process.env.REACT_APP_FIREBASE_APPCHECK_SITE_KEY;
if (appCheckSiteKey) {
  initializeAppCheck(firebaseApp, {
    provider: new ReCaptchaEnterpriseProvider(appCheckSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
}

export const auth = getAuth(firebaseApp);
export const googleProvider = new GoogleAuthProvider();
